import React from 'react';
import compose from 'lodash/fp/compose';
import { connect } from 'react-redux';
import hoistNonReactStatics from 'hoist-non-react-statics';
import { withRouterHooks } from '../withRouterHooks';
import { EditorState, convertToRaw } from 'draft-js';
import draftToHtml from 'draftjs-to-html';
import { convertToHTML } from 'draft-convert';
import * as mailActions from '../../../actions/dashboard/mail';
import { withDeleteConfirmation, withTranslation, withMsgInfo } from '..';
import { isEmptyValue } from '../../utils/checkValue';
import { BaseHOC, withBaseHOCProps } from '../common/BaseHOC';

let loaded = false;

const initialState = {
  to_mail: '',
  from_mail: '',
  subject: '',
  // message: "",
  message: EditorState.createEmpty(),
  area: '',
  sendMailLoading: false,
  openComposeForm: false,
};

export const withMail = (WrapperComponent) => {
  class Enhance extends BaseHOC {
    // constructor(props) {
    //   super(props)
    //   const blocksFromHTML = convertFromHTML(props.selectedMail?.message_html || '');
    //   this.state = {
    //     to_mail: "",
    //     from_mail: "",
    //     subject: "",
    //     // message: "",
    //     message: EditorState.createWithContent(
    //       ContentState.createFromBlockArray(
    //         blocksFromHTML.contentBlocks,
    //         blocksFromHTML.entityMap,
    //       )
    //     ),
    //     area: "",
    //     sendMailLoading: false,
    //     openComposeForm: false,
    //   }
    // };
    state = { ...initialState };

    timerId = null;

    async componentDidMount() {
      try {
        const { getAllMail, getMailServerInbox } = this.props;
        const getMailBoxes = async () => {
          getAllMail();
          getMailServerInbox();
        };
        if (!loaded) {
          await getMailBoxes();
          loaded = true;
        }
        const fiveMinutes = 5 * 60 * 1000;
        this.timerId = setInterval(getMailServerInbox, fiveMinutes);
      } catch (e) {
        loaded = true;
      }
    }

    componentWillUnmount() {
      this.timerId && clearInterval(this.timerId);
    }

    onChange = (e) => {
      const { value, name } = e.target;
      this.setState({ [name]: value });
    };

    redirectToInbox = () => {
      const { navigate } = this.props;
      navigate(-1);
    };

    sendMail = async () => {
      const { addMail, setMsgInfo, tr } = this.props;
      this.setState({ sendMailLoading: true });
      const state = { ...this.state };
      const html = draftToHtml(convertToRaw(state.message.getCurrentContent()));
      state.message = html;
      state.message_html = html;
      delete state.area;

      try {
        // Attempt to send the mail
        await addMail(state);
        setMsgInfo({
          success: true,
          msg: [`${tr('Mail sent successfully')}`],
        });
        // Reset state and loading flag on success
        this.redirectToInbox();
        this.setState({ ...initialState, sendMailLoading: false });
      } catch (error) {
        // Handle the error and reset loading flag
        console.error('Error sending mail:', error);
        this.setState({ sendMailLoading: false });
      }
    };

    updateMailArea = (area, rowIds) => {
      this.setState({ area });
      if (isEmptyValue(rowIds)) return;
      const { updateMailArea } = this.props;
      const payload = { ids: rowIds, area };
      updateMailArea(payload);
    };

    toggleComposeForm = (data) => {
      const { openComposeForm } = this.state;
      this.setState({
        ...(data ? data : initialState),
        openComposeForm: !openComposeForm,
      });
    };

    deleteBulkMail = async (data) => {
      const { deleteConfirmation, deleteBulkMail, tr } = this.props;
      try {
        const res = await deleteConfirmation.initBulk(deleteBulkMail, data, tr);
      } catch (e) {
        console.warn('Error deleting mail: ', e);
      }
    };

    deleteMailById = async (data) => {
      const { deleteConfirmation, deleteMailById, tr } = this.props;
      try {
        await deleteConfirmation.init(deleteMailById, data, tr);
      } catch (e) {
        console.warn('Error deleting mail: ', e);
      }
    };

    // deleteBulkMailPartially = async (data) => {
    //   const { deleteConfirmation, deleteBulkMailPartially } = this.props;
    //   try {
    //     await deleteConfirmation.initBulk(deleteBulkMailPartially, data);
    //   } catch (e) {}
    // };

    deleteBulkMailPartially = async (data) => {
      const { deleteBulkMailPartially } = this.props;
      await this._deleteBulk(deleteBulkMailPartially, data);
    };

    deleteMailByIdPartially = async (data) => {
      const { deleteConfirmation, deleteMailByIdPartially, tr } = this.props;
      try {
        await deleteConfirmation.init(deleteMailByIdPartially, data, tr);
      } catch (e) {
        console.warn('Error deleting mail: ', e);
      }
    };

    markMailAsRead = async (data) => {
      try {
        const { markMailAsRead, getAllMail } = this.props;
        const markMailAsReadAction = async () => {
          await markMailAsRead(data);
          await getAllMail();
        };
        await markMailAsReadAction();
      } catch (e) {}
    };
    markMailAsUnread = async (data) => {
      try {
        const { markMailAsUnread, getAllMail } = this.props;
        const markMailAsUnreadAction = async () => {
          await markMailAsUnread(data);
          await getAllMail();
        };
        await markMailAsUnreadAction();
      } catch (e) {}
    };
    undoMailDelete = async (data) => {
      try {
        const { undoMailDelete, getAllMail } = this.props;
        const undoMailDeleteAction = async () => {
          await undoMailDelete(data);
          await getAllMail();
        };
        await undoMailDeleteAction();
      } catch (e) {}
    };
    exportMail = async () => {
      try {
        const { exportMail } = this.props;
        await exportMail();
      } catch (e) {}
    };
    render() {
      const { state, props } = this;
      return (
        <WrapperComponent
          {...props}
          sendMail={this.sendMail}
          deleteMailById={this.deleteMailById}
          deleteBulkMail={this.deleteBulkMail}
          deleteMailByIdPartially={this.deleteMailByIdPartially}
          deleteBulkMailPartially={this.deleteBulkMailPartially}
          sendMailLoading={state.sendMailLoading}
          mailFormData={state}
          onMailChange={this.onChange}
          openComposeForm={state.openComposeForm}
          toggleComposeForm={this.toggleComposeForm}
          updateMailArea={this.updateMailArea}
          markMailAsRead={this.markMailAsRead}
          markMailAsUnread={this.markMailAsUnread}
          undoMailDelete={this.undoMailDelete}
          exportMail={this.exportMail}
          loaded={loaded}
        />
      );
    }
  }
  const mapStateToProps = ({ mail }) => ({ mail });
  const WithMail = connect(mapStateToProps, {
    ...mailActions,
  })(Enhance);
  hoistNonReactStatics(WithMail, WrapperComponent);
  return compose(
    withDeleteConfirmation,
    withBaseHOCProps,
    withRouterHooks,
    withTranslation,
    withMsgInfo,
  )(WithMail);
};
